import Vue from 'vue';
import VueRouter from 'vue-router';
import LocationTrace from '../view/LocationTrace/index.vue';
import VideoPlay from '../view/VideoPlay/index.vue';
import swiper from '../view/swiper/index.vue';
import Home from '../view/Home.vue';

Vue.use(VueRouter);

const routes = [
    {
        path: '/',
        name: 'Home',
        component: Home
    },
    {
        path: '/location-trace',
        name: 'LocationTrace',
        component: LocationTrace
    },
    {
        path: '/video-play',
        name: 'VideoPlay',
        component: VideoPlay
    },
    {
        path: '/swiper',
        name: 'swiper',
        component: swiper
    },
    // 其他路由配置
];

const router = new VueRouter({
    mode: 'hash', // 使用 HTML5 History 模式
    routes
});

export default router;